import React, { Component } from 'react';
import{
    Container,
    Col,
    Row,
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Input,
    Modal,
    ModalBody,
    ModalFooter,
    Button,
} from 'reactstrap';
/**
 * Used for the Listino Prezzi section. 
 */
class SelectFattura extends Component {

    constructor(props) {
        super(props);
        
        this.toggle = this.toggle.bind(this);
        this.toggleSearch = this.toggleSearch.bind(this);
        this.toggleSearchModal = this.toggleSearchModal.bind(this);

        this.state = {
             //dropdown open or closed
            dropdownOpen: false,
            //dropdown text that is displayed
            dropdownText: "Seleziona una Fattura", 
            //dropdown data
            clienti: [],
            //dropdown open or closed
            searchDropdown: false,
            //search text
            searchText: "",
            //clienti from search
            searchClienti: [],
            searchModal: false,
            isResultVisible: true,
        };
    
    }

    
    /**
     * Runs upon initial mount of the /listinoPrezzi path
     */

    dropdownOnSelect = (fattura) => {
        this.setState({
            dropdownText: `${fattura.fatturaId} - € ${fattura.importo} - ${fattura.dataFattura}`,
        }, () => this.props.fatturaSelected(fattura))
        
    }

    /**
     * Handles when the dropdown list is expanded or collapsed
     */
    toggle() {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen,
            isResultVisible: false,
        });
    }

    toggleSearch() {
        this.setState({
            searchDropdown: !this.state.searchDropdown
        });
    }

    handleSearchSubmit = (e) => {
        e.preventDefault();
        
        this.props.fatturaSearch();
        this.setState({
            isResultVisible: true,
        }, () => this.toggleSearchModal())
        
    }

    handleCancelSearch = () => {
        if(this.props.handleCancelSearch){
            this.props.handleCancelSearch();
        }

        this.toggleSearchModal();
        
    }
    toggleSearchModal = () => {
        this.setState({
            searchModal: !this.state.searchModal,
        })
    }
    
    /**
     * Renders the page
     */
    render() {

        const titolo = (
            <Container className="d-flex align-items-center justify-content-center">
              <h5 style={{color: "#011e41", fontWeight: "bold", margin: "0px"}}>Ricerca Fattura</h5>
            </Container>
        );

        //Creates the Level 2 Dropdown menu
        const FatturaDropDown = (
            <Container style={{paddingTop: "25px"}}>
                <Row>
                    <Col className="my-auto" style={{width: '100%', textAlign: 'center'}}>
                        <Dropdown style={{width: '100%', textAlign: 'center'}} isOpen={this.state.dropdownOpen} toggle={this.toggle}>
                            <DropdownToggle caret>
                                {this.state.dropdownText}
                            </DropdownToggle>
                            <DropdownMenu
                                modifiers={{
                                    setMaxHeight: {
                                      enabled: true,
                                      order: 890,
                                      fn: (data) => {
                                        return {
                                          ...data,
                                          styles: {
                                            ...data.styles,
                                            overflow: 'auto',
                                            maxHeight: "50vh",
                                          },
                                        };
                                      },
                                    },
                                    computeStyle: {
                                        gpuAcceleration: false
                                    }
                                }}> 
                                {this.props.fatture.map(fattura => {
                                    return (
                                        <DropdownItem key={fattura.fatturaId} id={fattura.fatturaId} onClick={() => this.dropdownOnSelect(fattura)} style={{color: "#011e41"}}>
                                            {`${fattura.fatturaId} - € ${fattura.importo} - ${fattura.dataFattura}`}
                                        </DropdownItem>
                                    )
                                })}
                            </DropdownMenu>
                        </Dropdown>
                    </Col>
                </Row>
            </Container>
        );

        const searchResult = (
            <Container style={{paddingTop: "25px"}}>
                <Row>
                    <Col className="my-auto" style={{width: '100%', textAlign: 'center'}}>
                        <Dropdown style={{width: '100%', textAlign: 'center'}} isOpen={this.state.searchDropdown} toggle={this.toggleSearch}>
                            <DropdownToggle caret>
                                Risultati di Ricerca
                            </DropdownToggle>
                            <DropdownMenu right 
                                modifiers={{
                                    setMaxHeight: {
                                      enabled: true,
                                      order: 890,
                                      fn: (data) => {
                                        return {
                                          ...data,
                                          styles: {
                                            ...data.styles,
                                            overflow: 'auto',
                                            maxHeight: "50vh",
                                          },
                                        };
                                      },
                                    },
                                    computeStyle: {
                                        gpuAcceleration: false
                                    }
                                  }}> 
                                {this.props.searchFatture.map(fattura => {
                                    return (
                                        <DropdownItem key={fattura.fatturaId} id={fattura.fatturaId} onClick={() => this.dropdownOnSelect(fattura)} style={{color: "#011e41"}}>
                                            {`${fattura.fatturaId} - € ${fattura.importo} - ${new Date(fattura.dataFattura).toLocaleDateString()}`}
                                        </DropdownItem>
                                    )
                                })}
                            </DropdownMenu>
                        </Dropdown >
                    </Col>
                </Row>  
            </Container>            
        );

        return (
            <Container className="d-flex align-items-start" fluid> 
                <Row className="d-flex justify-content-center align-items-center" style={{width: "100%", margin: "0px", padding: "0px"}}>
                    {titolo}
                    <Container className="d-flex align-items-center justify-content-center" style={{paddingTop: "25px"}}>
                        <Row className="d-flex align-items-center justify-content-center" style={{width: "100%"}}>
                            <Col className="d-flex align-items-center justify-content-center" xs={{size: 6}} style={{width: "100%"}}>
                                <h4 style={{color: "#011e41", fontWeight: "bold", margin: "0px"}}>Seleziona Fattura</h4>
                            </Col>
                        </Row>
                    </Container>
                    {FatturaDropDown}
                    <Container className="d-flex align-items-center justify-content-center" style={{paddingTop: "25px"}}>
                        <Row className="d-flex align-items-center justify-content-center" style={{width: "100%"}}>
                            <Col className="d-flex align-items-center justify-content-center" xs={{size: 6}} style={{width: "100%"}}>
                                <Button className="text-center" style={{width: '75%', padding: '0px', backgroundColor: "#011e41"}} onClick={this.toggleSearchModal}>
                                    Cerca Fattura
                                </Button>
                            </Col>
                        </Row>
                    </Container>
                    {this.props.searchComplete && this.state.isResultVisible ? 
                        <div>
                            {this.props.searchFatture.length > 0 ? searchResult : `fattura non trovato, ripetere la ricerca`}
                        </div> : null
                    }
                </Row>
                <Modal size="md" isOpen={this.state.searchModal} toggle={this.toggleSearchModal} style={{color: "#011e41"}}>
                    <ModalBody>
                        <Container>
                            <Row style={{borderBottom: "1px solid #011e41", marginBottom: "5px"}}>
                                <Col>
                                    <h3 style={{color: "#011e41", fontWeight: "bold", fontSize:"35px", margin: "0px"}}>Data:</h3>
                                </Col>
                            </Row>
                            <Row style={{marginBottom: "5px"}}>
                                <Col sm={2}>
                                    <h4 style={{color: "#011e41", fontWeight: "bold", margin: "0px"}}>da:</h4>                                                    
                                </Col>
                                <Col sm={6}>
                                    <Input id="dataDa" name="dataDa" type="date" onChange={this.props.handleFilterChange} value={this.props.dataDa} style={{height: "35px", width: "100%", padding: "0px", textAlign: "center", color: "#011e41", borderColor: "#011e41"}}/> 
                                </Col>
                            </Row>
                            <Row style={{marginBottom: "5px"}}>
                                <Col sm={2}>
                                    <h4 style={{color: "#011e41", fontWeight: "bold", margin: "0px"}}>a:</h4>                                                    
                                </Col>
                                <Col sm={6}>
                                    <Input id="dataA" name="dataA" type="date" onChange={this.props.handleFilterChange} value={this.props.dataA} style={{height: "35px", width: "100%", padding: "0px", textAlign: "center", color: "#011e41", borderColor: "#011e41"}}/> 
                                </Col>
                            </Row>
                            <Row style={{borderBottom: "1px solid #011e41", marginBottom: "5px"}}>
                                <Col>
                                    <h3 style={{color: "#011e41", fontWeight: "bold", fontSize:"35px", margin: "0px"}}>Importo:</h3>
                                </Col>
                            </Row>
                            <Row style={{marginBottom: "5px"}}>
                                <Col sm={2}>
                                    <h4 style={{color: "#011e41", fontWeight: "bold", margin: "0px"}}>da:</h4>                                                    
                                </Col>
                                <Col sm={6}>
                                    <Input id="importoDa" name="importoDa" type="number" onChange={this.props.handleFilterChange} value={this.props.importoDa} style={{height: "35px", width: "100%", padding: "0px", textAlign: "center", color: "#011e41", borderColor: "#011e41"}}/> 
                                </Col>
                            </Row>
                            <Row style={{marginBottom: "5px"}}>
                                <Col sm={2}>
                                    <h4 style={{color: "#011e41", fontWeight: "bold", margin: "0px"}}>a:</h4>                                                    
                                </Col>
                                <Col sm={6}>
                                    <Input id="importoA" name="importoA" type="number" onChange={this.props.handleFilterChange} value={this.props.importoA} style={{height: "35px", width: "100%", padding: "0px", textAlign: "center", color: "#011e41", borderColor: "#011e41"}}/> 
                                </Col>
                            </Row>
                        </Container>
                    </ModalBody>
                    <ModalFooter>
                        <Button className="text-center" style={{width: '25%', padding: '0px', backgroundColor: "#011e41", fontSize: "20px"}} onClick={this.handleCancelSearch}>
                           Annulla
                        </Button>
                        <Button className="text-center" style={{width: '25%', padding: '0px', backgroundColor: "#011e41", fontSize: "20px"}} onClick={this.handleSearchSubmit}>
                           Vai
                        </Button>
                    </ModalFooter>
                </Modal>
            </Container>
            
        )
    }
}

export default SelectFattura;


// WEBPACK FOOTER //
// ./src/components/NuovoVersamenti/SelectFattura.js